import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useLoading } from "../LoadingContext";
import "../dash.css";
import AdminNavbar from "./AdminNavbar";

function AdminLogin() {
  const navigate = useNavigate();
  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData(event.target);
    const email = formData.get("email");
    const password = formData.get("password");

    const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/auth/login/`;
    const headers = {
      "Content-Type": "application/json",
    };

    const data = {
      email,
      password,
      client: 1,
      calling_source: "archipel",
    };

    axios
      .post(apiEndpoint, data, { headers })
      .then((response) => {
        const { user_type, name, token } = response.data.data;
        // console.log(response.data);

        // Save name and role in localStorage
        localStorage.setItem("user_type", user_type);
        localStorage.setItem("name", name);
        localStorage.setItem("token", token); // Save token

        navigate("/admin_dashboard");
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(error);
        alert(error.response.data.message);
        setLoading(false);

        // alert("Invalid email or password");
        // Reset the error and redirect to the home page
        setError(null);
        navigate("/admin_login");
      });
  };

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Logging in...</h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <AdminNavbar />
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div
              className="card shadow-lg"
              style={{
                width: "100%",
                maxWidth: "400px",
                borderRadius: "15px",
                border: "none",
              }}
            >
              <div
                className="card-header text-center "
                style={{
                  backgroundColor: "#ced4da",
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                }}
              >
                <h4>ADMIN LOGIN</h4>
              </div>
              <div className="card-body text-center">
                <i className="fa-solid fa-user fa-2xl"></i>
                <form onSubmit={handleSubmit}>
                  <div className="input-group mb-3 mt-2">
                    <span className="input-group-text">
                      <i className="fa-regular fa-user"></i>
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      id="email"
                      name="email"
                      required
                    />
                  </div>
                  <div className="input-group mb-3">
                    <span className="input-group-text">
                      <i className="fa-solid fa-lock"></i>
                    </span>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      name="password"
                      id="password"
                      required
                    />
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-outline-secondary"
                      style={{ borderRadius: "10px" }}
                    >
                      LOG IN
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminLogin;
